module.exports = __webpack_public_path__ + "static/media/hello-beautiful@2x.dc396d79.png";